
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  mixins: [staticBlockMixin],
  inject: [
    'globalFormProvider',
    'setGlobalFormProviderProperties'
  ],
  props: {
    isVertical: {
      type: Boolean,
      required: false,
      default: false
    },
    pageTitle: {
      type: String,
      default: () => ''
    }
  },

  fetch () {
    if (+this.$route?.query?.form === this.mainFields.code?.value) {
      this.setFormSettings()
    }
  },
  methods: {
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.mainFields.code?.value,
        typeOfCard: this.pageTitle,
        productList: [{ name: this.pageTitle }],
        isLong: this.$attrs?.['is-long'] || this.blockParams?.isLong
      })
    },
    openModal () {
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.mainFields.code?.value } })
    }
  }
})
